import { render, staticRenderFns } from "./AcceptanceErrors.vue?vue&type=template&id=480cd08e&"
import script from "./AcceptanceErrors.vue?vue&type=script&lang=js&"
export * from "./AcceptanceErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports